import React from 'react';
import PropTypes from 'prop-types';

export default function Banner(props) {
    const { title, text, onClose } = props;

    return (
        <div className="banner">
            <div className="banner-header">
                <h3 className="banner-title">{title}</h3>
                <span className="icon-circle-close" onClick={onClose}></span>
            </div>
            <p className="banner-text" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
}

Banner.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    onClose: PropTypes.func
};
